import { omit } from "lodash";

import {
  convertFilterItems,
  convertTagsFilterItems,
} from "./util/convertFilterItems";
import splitSearchTerms from "./util/splitSearchTerms";

import * as ACTIONS from "./actionTypes";
import type { QueryVariables, SidebarAction, SidebarState } from "./types";

export default (state: SidebarState, action: SidebarAction): SidebarState => {
  switch (action.type) {
    case ACTIONS.QUERY_COMPLETE: {
      const { data } = action;
      return {
        ...state,
        query: {
          ...state.query,
          loading: false,
          isLoaded: true,
        },
        filterItems: {
          ...state.filterItems,
          ...convertFilterItems(data),
        },
      };
    }
    case ACTIONS.TAGS_QUERY_COMPLETE: {
      const { data } = action;
      return {
        ...state,
        query: {
          ...state.query,
          loading: false,
        },
        filterItems: {
          ...state.filterItems,
          ...convertTagsFilterItems(data),
        },
      };
    }
    case ACTIONS.QUERY_ERROR: {
      const { error } = action;
      return {
        ...state,
        query: {
          ...state.query,
          loading: false,
          error,
        },
      };
    }

    case ACTIONS.SELECT_SIDEBAR_TAB: {
      const { selectedTab } = action;
      return {
        ...state,
        selectedTab: selectedTab || state.selectedTab,
      };
    }
    case ACTIONS.FILTER_ITEM_USER_SEARCH: {
      const { key, value } = action;

      const others = omit(state.query.variables, [
        "searchTermsKey",
        "searchTermsValues",
      ]);

      let searchVariables: QueryVariables = {};
      if (key && value) {
        searchVariables = {
          searchTermsKey: key,
          searchTermsValues: splitSearchTerms(value),
        };
      }

      const searchTerms = splitSearchTerms(value);
      return {
        ...state,
        filterItemSearch: {
          key,
          searchTerms,
        },
        query: {
          ...state.query,
          variables: {
            ...others,
            ...searchVariables,
          },
          loading: true,
        },
      };
    }
    default: {
      const exhaustiveCheck: never = action;
      void exhaustiveCheck;
      return state;
    }
  }
};
